import { useCallback } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import { KNOWLEDGE_ARTICLE } from 'customer-data-objects/constants/ObjectTypes';
import { CampaignFilter } from 'campaigns-lib/campaignsPlatform';
import { useGetQuickFilterValue, useListingLibQuickFilters } from 'framework-listing-lib/hooks/useQuickFilters';
import { EQ } from 'framework-listing-lib/utils/filters';
import { useObjectTypeHasCampaignsAccess } from 'campaigns-lib/campaignsPlatform';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ArticlesCampaignFilter() {
  const {
    removeQuickFilter,
    setQuickFilter
  } = useListingLibQuickFilters();
  const hasCampaignsAccess = useObjectTypeHasCampaignsAccess(KNOWLEDGE_ARTICLE);
  const getQuickFilterValue = useGetQuickFilterValue();
  const campaignValue = getQuickFilterValue('hs_campaign');
  const handleSelectCampaign = useCallback(value => {
    removeQuickFilter('hs_campaign');
    const selectedValue = Array.isArray(value) ? value[0] : value;
    if (value !== '') {
      setQuickFilter(EQ('hs_campaign', selectedValue));
    }
  }, [removeQuickFilter, setQuickFilter]);
  if (!hasCampaignsAccess) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    paddingInlineStart: "400",
    paddingInlineEnd: "400",
    children: /*#__PURE__*/_jsx(CampaignFilter, {
      objectType: KNOWLEDGE_ARTICLE,
      value: campaignValue === '' ? unescapedText('knowledgeContentUI.shared.filters.campaigns') : campaignValue,
      showLabel: false,
      onChange: (_event, option) => {
        if (option && !Array.isArray(option)) {
          handleSelectCampaign(option.display_name || '');
        } else {
          handleSelectCampaign('');
        }
      }
    })
  });
}